import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { clientLabel } from "@/lib/format";

export function useApi(path, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState("");
  const key = path ? `${path}${JSON.stringify(params || {})}` : null;

  const load = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    try {
      const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== "" && v != null));
      const r = await api.get(path, { params: clean });
      setData(r.data);
      setError("");
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load, setData };
}

export function useDirectory() {
  const { data } = useApi("/users/directory");
  const list = data || [];
  const name = (id) => list.find((u) => u.id === id)?.name || "—";
  return { staff: list, options: list.map((u) => ({ value: u.id, label: u.name })), name };
}

export function useClientOptions() {
  const { data } = useApi("/clients");
  return (data || []).map((c) => ({ value: c.id, label: clientLabel(c) }));
}
